<div *ngIf="{userRegistrationNotFound: userRegistrationNotFound$ | async,
             isResetSuccessed: isResetSuccessed$ | async,
             recaptchaSiteKey: recaptchaSiteKey$ | async,
             resetPasswordModel: resetPasswordModel$ | async} as data" class="container">
    <a [routerLink]="['/']" class="back">
        <svg-icon class="back__icon" src="/assets/icons/chevron-left.svg" class="chevron"></svg-icon>
        <span class="back__text">{{'label.ReturnToMainPage' | translate}}</span>
    </a>

    <form class="form" [formGroup]="submitForm" [appConnectForm]="data.resetPasswordModel" #ngForm="ngForm" (ngSubmit)="submitResetPasswordForm(ngForm)">
        <mat-form-field appearance="outline" class="form-field">
            <mat-label>{{ 'label.Email' | translate }}</mat-label>
            <input matInput type="email" formControlName="email" />
            <mat-error 
              *ngIf="submitForm.controls['email'].hasError('required') && (submitForm.controls['email'].touched || ngForm.submitted)">
              {{'message.MandatoryField' | translate}}
            </mat-error>
        </mat-form-field>        

        <div class="recaptcha">
            <div style="transform:scale(0.9);transform-origin:0;">
              <re-captcha formControlName="recaptcha" siteKey="{{ data.recaptchaSiteKey }}"></re-captcha>
            </div>
            <mat-error
              *ngIf="(submitForm.controls['recaptcha'].touched || ngForm.submitted) && submitForm.controls['recaptcha'].errors?.required">
              {{'message.MandatoryField' | translate}}
            </mat-error>
        </div>
          
        <div class="button">
            <button (click)="resetPassword()" class="button__btn" type="submit">
              {{ 'label.PasswordRecovery' | translate }}
            </button>
        </div>

        <div class="message">
          <div *ngIf="data.userRegistrationNotFound" class="message__error">
            {{'message.UserRegistrationNotFound' | translate}}
          </div>
        </div>

        <div class="message">
          <div *ngIf="data.isResetSuccessed"  class="message__success">
            {{'message.PasswordIsReset' | translate}}
          </div>
        </div>
    </form>
</div>